import { CoversTagKey, fetchCoversByTagThunk, selectCoversMetaState } from '@/redux/slices/coverSlice'
import { fetchTodayStatsThunk } from '@/redux/slices/currentUserSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { BaseFileEnum } from '@/typings/domain'
import { useFocusEffect } from 'expo-router'
import { useCallback, useMemo } from 'react'
import CoverList from './CoverList'

const includeFolderTags = [CoversTagKey.MyBaseFiles, CoversTagKey.SharedForms, CoversTagKey.Favorates]

type Props = {
  activeTag: CoversTagKey
  ListHeaderComponent?: React.ReactElement
}

export default function CoversByFilter({ activeTag, ListHeaderComponent }: Props) {
  const dispatch = useAppDispatch()

  const includeFolder = useMemo(() => includeFolderTags.includes(activeTag), [activeTag])
  const formCoversLoaded = useAppSelector(
    state => selectCoversMetaState(state, { tag: activeTag }, BaseFileEnum.Form).loaded
  )
  const folderCoversLoaded = useAppSelector(
    state => selectCoversMetaState(state, { tag: activeTag }, BaseFileEnum.FormFolder).loaded
  )

  const refetchCovers = useCallback(() => {
    includeFolder && dispatch(fetchCoversByTagThunk({ tag: activeTag, type: BaseFileEnum.FormFolder, reset: true }))
    dispatch(fetchCoversByTagThunk({ tag: activeTag, type: BaseFileEnum.Form, reset: true }))
    dispatch(fetchTodayStatsThunk())
  }, [activeTag, dispatch, includeFolder])

  useFocusEffect(refetchCovers)

  const handleLoadMore = useCallback(
    (type: BaseFileEnum) => {
      dispatch(fetchCoversByTagThunk({ tag: activeTag, type }))
    },
    [activeTag, dispatch]
  )

  const handleRefresh = useCallback(() => {
    dispatch(fetchTodayStatsThunk())
    refetchCovers()
  }, [dispatch, refetchCovers])

  const initialLoading = (!includeFolder || !folderCoversLoaded) && !formCoversLoaded

  return (
    <CoverList
      tag={activeTag}
      includeFolder={includeFolder}
      onLoadMore={handleLoadMore}
      onRefresh={handleRefresh}
      ListHeaderComponent={ListHeaderComponent}
      initialLoading={initialLoading}
    />
  )
}
